import { render, staticRenderFns } from "./selfInvestment.vue?vue&type=template&id=8e4b8cc6&scoped=true"
import script from "./selfInvestment.vue?vue&type=script&lang=js"
export * from "./selfInvestment.vue?vue&type=script&lang=js"
import style0 from "./selfInvestment.vue?vue&type=style&index=0&id=8e4b8cc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4b8cc6",
  null
  
)

export default component.exports